import { Component, EventEmitter, OnInit } from '@angular/core';
import { CourseNavigationService } from '../../../services/course-navigation.service';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwMetaDataListCardConfigData, DwQueryMetaData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CourseEntity } from '../../../../../meta-data/app-meta-data.service';
import { SchoolRepositoryService } from '../../../../schools/services/school-repository.service';


@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Course Marketplace Card',
  key: 'courseMarketplaceCard',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Course,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-course-marketplace-card',
  templateUrl: './course-marketplace-card.component.html',
  styleUrls: ['./course-marketplace-card.component.scss']
})
export class CourseMarketplaceCardComponent implements DwCardBaseComponent<any, CourseEntity> {
  cardText = 'No courses have been assigned to you yet.';

  isMarketplaceEnabled: boolean;
  setupComplete = false;
  isMarketplaceCard: boolean;

  constructor(private courseNavigationService: CourseNavigationService,
    private schoolRepositoryService: SchoolRepositoryService
  ) { }

  cardConfig?: any;
  data?: CourseEntity;
  resolvedContext?: any;
  queryMetaData?: DwQueryMetaData;

  setupCard() {
    
  }

  cardClick: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.schoolRepositoryService.getSchoolFeatures()
      .subscribe((schoolFeatures) => {
        this.isMarketplaceEnabled = schoolFeatures.IsMarketplaceEnabled;

        if (this.isMarketplaceEnabled) {
          this.cardText = 'No courses have been assigned to you yet.';

          this.isMarketplaceCard = this.queryMetaData?.QueryMeaning?.indexOf('Marketplace') > -1;

          if (this.isMarketplaceCard) {
            this.cardText = 'No courses are available for purchase right now.';
          }
        } else {
          this.cardText = 'Contact your school for courses to be assigned.';
        }

        this.setupComplete = true;
      });
  }

  click() {
    this.courseNavigationService.navigateToMyCourses();
  }
}
